import { Link, LinkProps } from '@postidigital/posti-components'
import { BrandTheme } from '@postidigital/posti-theme'
import { observer } from 'mobx-react-lite'
import React, { ComponentPropsWithRef, FC } from 'react'
import styled, { css, useTheme } from 'styled-components'

import { layoutStore } from '../../store'

type ResponsiveLinkComponentProps = Omit<LinkProps, 'size'> & {
  size?: LinkProps['size']
  iconPosition?: 'left' | 'right'
} & ComponentPropsWithRef<typeof Link>

const ResponsiveLinkComponent: FC<ResponsiveLinkComponentProps> = ({
  children,
  iconPosition = 'right',
  ...linkProps
}) => {
  const { colorTokens: color } = useTheme()
  const size = linkProps.size || (!layoutStore.isDesktop ? 'sm' : 'md')
  const linkColor = linkProps.color || linkProps.style?.color || color.postiOrange70

  return (
    <StyledLink
      {...linkProps}
      size={size}
      iconColor={linkColor}
      $iconPosition={iconPosition}
      style={{ margin: 0, padding: 0, fontWeight: BrandTheme.fontWeight.bold, ...linkProps.style, color: linkColor }}
    >
      {children}
    </StyledLink>
  )
}

const StyledLink = styled(Link)<{ iconColor: string; $iconPosition: 'left' | 'right' }>(
  ({ iconColor, $iconPosition }) => css`
    display: inline-block;

    ${$iconPosition === 'left' &&
    css`
      grid-template-columns: [leadingIcon] min-content [content] minmax(0, 1fr);

      & > span {
        grid-column: content;
      }

      & > svg {
        grid-column: leadingIcon;
        grid-row: 1;
      }
    `}

    & > svg {
      margin-left: 8px;

      & > path {
        ${iconColor &&
        css`
          // Lack of handles for specificity
          stroke: ${iconColor} !important;
          stroke-width: 2 !important;
        `}
      }
    }
  `
)

export const ResponsiveLink = observer(ResponsiveLinkComponent)
